import { GenericModelSchema, ModelSchema } from './ModelSchema';

type Loader<P, C> = (parent: P, childSchema: GenericModelSchema) => ReadonlyArray<C> | C | null;

// TODO: no any
export type GenericLoader = Loader<any, any>;

function getKey(parentType: string, childType: string) {
  return `${parentType}.${childType}`;
}

export class ModelChildLoader {
  defaultLoader?: GenericLoader;
  loaders = new Map<string, GenericLoader>();

  addDefault(loader: GenericLoader) {
    this.defaultLoader = loader;
  }

  add<P, C>(parent: ModelSchema<P>, child: ModelSchema<C>, loader: Loader<P, C>) {
    this.loaders.set(getKey(parent.type, child.type), loader);
  }

  remove<P, C>(parent: ModelSchema<P>, child: ModelSchema<C>) {
    this.loaders.delete(getKey(parent.type, child.type));
  }

  // TODO: any = bad
  getChildrenOf<C>(parent: any, child: ModelSchema<C>): C | C[] {
    const formatChild = (childData: any) => {
      if (childData.type) return childData;
      return {
        ...childData,
        type: child.type,
      };
    };

    const dataFromLoader = this.loadChildData(parent, child) || [];

    return Array.isArray(dataFromLoader) ? dataFromLoader.map(formatChild) : formatChild(dataFromLoader);
  }

  private loadChildData<C>(parent: any, child: ModelSchema<C>): C | C[] {
    const key = getKey(parent.type, child.type);

    if (this.loaders.has(key)) {
      return this.loaders.get(key)!(parent, child);
    }

    if (this.defaultLoader) {
      return this.defaultLoader(parent, child);
    }

    return [];
  }
}
